module.exports = __webpack_public_path__ + "mainassets/img/envelope.919c5d2b.svg";